import BMXChip from "./../../../Components/Chip/BMXChip";
import "./ServiceStatusOfTodayBox.scss";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { Icon } from "@mui/material";
import moment from "moment";
import { goToService } from "../../../Utils/Redirects/Redirects";

export const Ticket = (props) => {
  const { service } = props;
  const { t } = useTranslation();
  const hexToRgba = (hex, alpha = 0.2) => {
    if (!hex) return "rgba(0,0,0,0.05)";
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const getLocation = (location, t) => {
    switch (location) {
      case "customerIntervention":
        return {
          icon: "directions_car",
          title: t("global:service.customerIntervention"),
        };

      case "localIntervention":
        return {
          icon: "corporate_fare",
          title: t("global:service.localIntervention"),
        };

      case "remoteIntervention":
        return {
          icon: "record_voice_over",
          title: t("global:service.remoteIntervention"),
        };

      default:
        return null;
    }
  };

  const locationData = getLocation(service?.location, t);
  const statusColor = service?.status?.color?.background;

  const techniciansCount = service?.groupSize ?? 0;
  const formatTime = (dateTime) => {
    return dateTime ? moment(dateTime).format("HH:mm") : "--:--";
  };
  return (
    <div
      className="ticket"
      onClick={() => goToService(service?.uuid)}
      style={{ background: hexToRgba(statusColor), cursor: "pointer" }}
    >
      <div className="leftBar" style={{ background: `${statusColor}` }}>
        <div>
          {service.urgent ? (
            <Tooltip title={t("global:service.urgent")} placement="top">
              <Icon style={{ color: "red" }}>warning</Icon>
            </Tooltip>
          ) : (
            ""
          )}
        </div>

        <div>
          <Tooltip
            className="d-flex flex-column  align-items-center"
            title={t("global:technics")}
            placement="top"
          >
            <Icon>people_alt</Icon>
            <span style={{ fontSize: "0.7em" }}>{`+${techniciansCount}`}</span>
          </Tooltip>

          {locationData && (
            <Tooltip
              className="d-flex flex-column align-items-center"
              title={locationData.title}
              placement="top"
            >
              <Icon>{locationData.icon}</Icon>
            </Tooltip>
          )}
        </div>
      </div>

      <div className="content">
        <h4>{service?.index}</h4>
        <p> {service?.client?.name}</p>
        <p>
          {`${service.device?.branch?.city}, ${service.device?.branch?.address}`}
        </p>

        <h5>
          {`${service?.device?.printerModel?.manufacturer?.entryName} ${service?.device?.printerModel?.modelName} `}
        </h5>
        <div className="d-flex justify-content-between align-items-center mt-2">
          <BMXChip
            className="chipServiceStatus"
            width="fit-content"
            size="small"
            backgroundColor={statusColor}
            label={service?.status?.name}
            font={service?.status?.color?.font}
          />

          <span className="hours">
            {formatTime(service.startTime)} – {formatTime(service.endTime)}
          </span>
        </div>
      </div>
    </div>
  );
};
export default Ticket;
